import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { send } from '../../../actions/network';
import HistoryItem from '../../../components/HistoryItem/HistoryItem';
import makeHistoryItemPropsSelector from '../../../components/HistoryItem/HistoryItem.selector';
import useMergeProps from '../../../hooks/useMergeProps';
import useRouter from '../../../hooks/useRouter';
import { makeEntitiesBetslipsEntityStateByBetslipRefSelector } from '../../../selectors/betslip.selector';
import { StateType } from '../../../states';
import { type KLCollectibleStatus } from '../types/collectible';
type KLCollectibleBetslipDetailsCardContainerProps = {
  className?: string;
  status: KLCollectibleStatus;
  betslipReference: string;
};

const StyledHistoryItem = styled(HistoryItem)`
  width: 100%;
`;

const KLCollectibleBetslipDetailsCardContainer = (ownProps: KLCollectibleBetslipDetailsCardContainerProps) => {
  const dispatch = useDispatch();
  const { history } = useRouter();

  const { betslipReference } = ownProps;

  const selectBetslip = useMemo(() => makeEntitiesBetslipsEntityStateByBetslipRefSelector(), []);
  const betslip = useSelector((state: StateType) => selectBetslip(state, { betslipReference }));
  const selectorProps = useMemo(() => ({ id: betslip?.betslipId, history }), [betslip?.betslipId, history]);
  const selector = useMemo(() => makeHistoryItemPropsSelector(), []);
  const selectedProps = useSelector((state: StateType) => selector(state, selectorProps));

  const getBetslip = useCallback(
    () => dispatch(send({ getOneBetslip: { betslipReference } })),
    [betslipReference, dispatch],
  );

  useEffect(() => {
    getBetslip();
  }, [getBetslip]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  // @ts-ignore
  return betslip ? <StyledHistoryItem {...enhancedProps} isCashoutHidden hideMoreButton /> : null;
};

export default KLCollectibleBetslipDetailsCardContainer;
